export default __webpack_public_path__ + "static/media/piano.6b32a278.png";